import { ProgressBar } from "@adeccoux/tag-ds";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BaseContext } from "../../App";
import {
    CommonLoader,
    CommonPopup,
    CommonQuesProgress,
    QuesLoader,
    SessionExpireCommonPopup,
    useScreenTransition,
    useTimer,
    redirectToAssessmentSummary,
    useTimerValues,
} from "../../util/common";
import { TEST_COMPLETE, TEST_QUESTIONS } from "../../util/constants";
import { getNoCacheCall, postCall } from "../../util/resources";
import SesHeader from "../header";
import Q35 from "./q35";
import SingleSelectTab from "./singleSelectTab";

const TestTaker32 = () => {
    const [test, setTest] = useState();
    const [singleSelectData, setSingleSelectData] = useState("-1");
    const [freeFieldData, setFreeFieldData] = useState("");
    const [multiSelectData, setMultiSelectData] = useState("-1");
    const [textData, setTextData] = useState("");
    const [sessionStatus, setSessionStatus] = useState(false);
    const [popupData, setpopupData] = useState({
        isOpen: false,
        popupHeader: "",
        popupBody: "",
        popupFooter: "",
    });
    const { min, sec, totalSecLeft, startTimer, stopTimer } = useTimer();
    const { setLoading } = useContext(BaseContext);
    const { phase, loading, startTransition, done } = useScreenTransition();
    const location = useLocation();
    const phrases = location.state.user.siteConfig.phrases;
    const navigate = useNavigate();
    const formRef = useRef();
    const exampleTest = useRef();
    const quesNo = useRef(-1);
    const timerStarted = useRef(false);
    const stepRef = useRef();
    const attachKeyListenRef = useRef();
    const keyMappings = useRef({});
    const header = useRef({
        "x-xpert-session": location.state.user.sessionId,
        "Content-Type": "application/json",
    });
    const firstPrev = useRef(0);
    const { timerOverallAssessment } = useTimerValues();

    const buildMediaUrl = (file) => {
        let builtUrl =
            window.location.protocol +
            "//" +
            window.location.hostname +
            "/static";
        builtUrl += (file.startsWith("/") ? "" : "/") + file;
        return builtUrl;
    };

    const detectKeyDown = (e) => {
        if (!loading) {
            if (
                e.code in keyMappings.current &&
                test.questions[0].answers?.[0]?.groupId === "1"
            ) {
                setSingleSelectData(keyMappings.current[e.code]);
            } else if (
                e.code in keyMappings.current &&
                test.questions[0].answers?.[0]?.groupId === "2"
            ) {
                updateMultiSelect(keyMappings.current[e.code]);
            }
            if (nextAllowed() && e.code === "Space") {
                nextNavigate();
            }
        }
    };

    const prepareMultiSelect = (answerArray, preVal = false) => {
        let temp = [];
        if (preVal !== false) {
            const userChoice = parseInt(answerArray, 10);
            const aa = preVal,
                aal = preVal.length;
            for (let i = 0; i < aal; i++) {
                if (userChoice & Math.pow(2, i) && userChoice !== -1) {
                    temp.push(true);
                } else {
                    temp.push(false);
                }
            }
        } else {
            temp = [...Array(answerArray.length)].map(() => {
                return false;
            });
        }
        setMultiSelectData(temp);
    };

    const prepareAns = () => {
        let answer = "";
        if (
            !test.questions[0].answers ||
            test.questions[0].answers?.length === 0
        ) {
            answer = "-1";
        } else {
            if (test.questions[0].answers?.[0]?.groupId === "1") {
                answer = singleSelectData;
            } else if (test.questions[0].answers?.[0]?.groupId === "2") {
                let av = null,
                    a;
                const aa = multiSelectData;
                const aal = aa.length;

                for (let i = 0; i < aal; i++) {
                    a = aa[i];
                    if (a) {
                        av += Math.pow(2, i);
                    }
                }
                answer = av;
            } else if (test.questions[0].answers?.[0]?.groupId === "3") {
                answer = textData;
            }
        }
        if (test.questions[0].freeField) {
            answer += "#$#" + freeFieldData;
        }
        return answer;
    };

    const nextAllowed = () => {
        if (
            test.questions[0].freeField &&
            (!test.questions[0].answers ||
                test.questions[0].answers?.length === 0)
        ) {
            return freeFieldData.length > 0;
        } else if (test.questions[0].answers?.[0]?.groupId === "1") {
            return singleSelectData != "-1";
        } else if (test.questions[0].answers?.[0]?.groupId === "2") {
            let allowed = false;
            multiSelectData != "-1" &&
                multiSelectData.map((val, ind) => {
                    if (val) {
                        allowed = true;
                    }
                });
            return allowed;
        } else if (test.questions[0].answers?.[0]?.groupId === "3") {
            return textData.length > 0;
        }
    };

    const updateMultiSelect = (ind) => {
        setMultiSelectData((prev) => {
            let newArr = [...prev];
            newArr[ind] = !newArr[ind];
            return newArr;
        });
    };

    const generateKeyMapping = (answers) => {
        if (answers && answers?.length > 0) {
            let key;
            keyMappings.current = {};
            answers.map((val) => {
                key = `Digit${val.position + 1}`;
                keyMappings.current = {
                    ...keyMappings.current,
                    [key]: val.position,
                };
            });
        }
    };

    const nextNavigate = async (prev = false) => {
        startTransition(async () => {
            formRef.current.reportValidity();
            if (formRef.current.checkValidity()) {
                if (prev === true) {
                    quesNo.current -= 1;
                    firstPrev.current += 1;
                } else {
                    firstPrev.current = 0;
                }
                if (location.state.warmUp) {
                    if (test.lastPage && prev !== true) {
                        stopTimer();
                        navigate("/TT32", {
                            state: { ...location.state, warmUp: false },
                        });
                    } else {
                        if (prev === true) {
                            quesNo.current -= 1;
                        }
                        await getQuestion();
                    }
                } else {
                    const elapsedTime = stopTimer();
                    const ansObj = {
                        answers: [],
                        structure: null,
                        value: prepareAns(),
                    };
                    let quesObj = test.questions;
                    quesObj[0].userAnswer = ansObj;
                    const otherData = {
                        duration: location.state.test.duration + elapsedTime,
                        pause: firstPrev.current === 1,
                    };
                    try {
                        let response;
                        if (prev === "timeEnded") {
                            stopTimer();
                            response = await postCall(
                                TEST_COMPLETE + location.state.test.id,
                                { ...otherData, questions: quesObj },
                                header.current
                            );
                        } else if (test.lastPage && prev !== true) {
                            stopTimer();
                            response = await postCall(
                                TEST_COMPLETE + location.state.test.id,
                                { ...otherData, questions: quesObj },
                                header.current
                            );
                        } else {
                            response = await postCall(
                                TEST_QUESTIONS + location.state.test.id,
                                { ...otherData, questions: quesObj },
                                header.current
                            );
                        }
                        if (response.data.status === true) {
                            if (
                                (test.lastPage && prev !== true) ||
                                prev === "timeEnded"
                            ) {
                                redirectToAssessmentSummary(location, navigate);
                            } else {
                                setSingleSelectData(-1);
                                setMultiSelectData(-1);
                                setFreeFieldData("");
                                setTextData("");
                                formRef.current.reset();
                                if (prev !== true) quesNo.current += 1;
                                await getQuestion();
                            }
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            }
            done();
        });
    };

    const getQuestion = async () => {
        if (location.state.warmUp) {
            setTest(exampleTest.current[quesNo.current]);
            quesNo.current += 1;
        } else {
            try {
                const response = await getNoCacheCall(
                    TEST_QUESTIONS +
                    location.state.test.id +
                    "/" +
                    quesNo.current,
                    header.current
                );
                quesNo.current = response.data[0].endNumber;
                setTest(response.data[0]);
                generateKeyMapping(response.data[0].questions[0].answers);
                if (response.data[0].questions[0].userAnswer !== null) {
                    const userAnswer =
                        response.data[0].questions[0].userAnswer.value.split(
                            "#$#"
                        );
                    const userChoice = userAnswer[0];
                    const userText = userAnswer[1] ? userAnswer[1] : "";
                    if (
                        response.data[0].questions[0].answers?.[0]?.groupId ===
                        "1"
                    ) {
                        setSingleSelectData(userChoice);
                    } else if (
                        response.data[0].questions[0].answers?.[0]?.groupId ===
                        "2"
                    ) {
                        prepareMultiSelect(
                            userChoice,
                            response.data[0].questions[0].answers
                        );
                    } else if (
                        response.data[0].questions[0].answers?.[0]?.groupId ===
                        "3"
                    ) {
                        setTextData(userChoice);
                    }
                    setFreeFieldData(userText);
                } else if (
                    response.data[0].questions[0].answers?.[0]?.groupId === "2"
                ) {
                    prepareMultiSelect(
                        response.data[0].questions[0].answers,
                        false
                    );
                }
                if (timerStarted.current) {
                    startTimer();
                }
            } catch (error) {
                console.log();
            }
        }
    };

    const exitTest = () => {
        if (location.state.warmUp) {
            navigate("/instructions", {
                state: { ...location.state, warmUp: false },
            });
        } else {
            setpopupData((prev) => {
                prev = {
                    ...prev,
                    isOpen: true,
                    popupHeader: location.state.test.name,
                    popupBody: phrases?.["1002189"],
                    popupFooter: phrases?.["14392"],
                };
                return prev;
            });
        }
    };

    const closePopUp = () => {
        setpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
        stopTimer();
        navigate("/");
    };

    const approveAction = async () => {
        const elapsedTime = stopTimer();
        const ansObj = {
            answers: [],
            structure: null,
            value: prepareAns(),
        };
        let quesObj = test.questions;
        quesObj[0].userAnswer = ansObj;
        const otherData = {
            duration: location.state.test.duration + elapsedTime,
        };
        const response = await postCall(
            TEST_COMPLETE + location.state.test.id,
            { ...otherData, questions: quesObj },
            header.current
        );
        redirectToAssessmentSummary(location, navigate);
    };

    useEffect(() => {
        if (test) {
            if (location.state.test.bShowTimer && !timerStarted.current) {
                timerStarted.current = true;
                startTimer(
                    location.state.test.timeLimit - location.state.test.duration
                );
            }
            attachKeyListenRef.current?.focus({
                preventScroll: true,
            });
        }
    }, [test]);

    useEffect(() => {
        if (totalSecLeft === 0) {
            setSessionStatus(true);
        }
        if (test && location.state.test.bShowTimer) {
            stepRef.current.children[1].children[0].setAttribute(
                "data-secLeft",
                `${min}:${sec}`
            );
        }
    }, [totalSecLeft]);

    useEffect(() => {
        setSingleSelectData(-1);
        setMultiSelectData(-1);
        setFreeFieldData("");
        setTextData("");
        if (location.state.warmUp) {
            exampleTest.current = location.state.test.testExample;
            quesNo.current = 0;
        }
        getQuestion();
    }, [location.state.warmUp]);

    const sessionApproveAction = async () => {
        setSessionStatus(false);
        nextNavigate("timeEnded");
    };

    if (!test) {
        return <CommonLoader />;
    }

    return (
        <form ref={formRef} style={{ width: "100%" }}>
            <div
                className="g-container flex_col p4 g5 pt0_mobile g2_mobile full-width"
                style={{ outline: "none" }}
                ref={attachKeyListenRef}
                tabIndex="-1"
                onKeyDown={detectKeyDown}
                onBlur={(e) => {
                    if (test.freeField) {
                        e.target.focus({
                            preventScroll: true,
                        });
                    }
                }}
            >
                <SesHeader clientCobranding={location.state.cobrandingLink} />
                <div
                    ref={stepRef}
                    className="top-progress-container flex_row  sticky full-width g2 bg01"
                >
                    <CommonQuesProgress test={test} />
                    {location.state.test.bShowTimer && (
                        <ProgressBar
                            circular
                            step={totalSecLeft}
                            steps={location.state.test.timeLimit}
                            circularColorClass={
                                timerOverallAssessment !== undefined &&
                                    totalSecLeft <= timerOverallAssessment
                                    ? "progress-bar-color"
                                    : ""
                            }
                        />
                    )}
                </div>

                <div className="flex_col g2">
                    <h3>
                        {location.state.warmUp
                            ? location.state.test.testExampleName
                            : location.state.test.name}
                    </h3>
                    <div
                        className="base questionText"
                        dangerouslySetInnerHTML={{
                            __html: test.questions[0].topicInstruction,
                        }}
                    />
                </div>
                <div
                    className={
                        location.state.test.displayType === "3"
                            ? "flex_col g2 position_relative"
                            : "flex_row flex_col_tablet g2 position_relative"
                    }
                >
                    <QuesLoader show={phase === "showing-loader"} />
                    <div className={`flex_col flex_gsb g2 shown ${phase}`}>
                        <div className="small-title">{phrases?.["13106"]}</div>
                        <div className="flex_col g2 base p4 roundness_1 border_tt82 full-height">
                            {location.state.test.displayType !== "3" &&
                                test.questions.map(
                                    (val, ind) =>
                                        val.questionImage && (
                                            <img
                                                key={val.id}
                                                src={buildMediaUrl(
                                                    val.questionImage
                                                )}
                                                alt="question-image"
                                                className="ques-img"
                                            />
                                        )
                                )}
                            {location.state.test.displayType !== "3" &&
                                test.questions.map(
                                    (val, ind) =>
                                        val.media &&
                                        val.media.map((media, ind) => (
                                            <img
                                                key={media.id}
                                                src={buildMediaUrl(media.url)}
                                                alt="question-image"
                                                className="ques-img"
                                            />
                                        ))
                                )}
                            {location.state.test.displayType !== "3" &&
                                test.questions.map(
                                    (val, ind) =>
                                        val.questionText && (
                                            <div
                                                key={val.id}
                                                className="questionText"
                                                dangerouslySetInnerHTML={{
                                                    __html: val.questionText,
                                                }}
                                            />
                                        )
                                )}
                            {location.state.test.displayType === "3" && (
                                <img
                                    src={buildMediaUrl(
                                        test.questions[0].questionImage
                                    )}
                                    alt="question-image"
                                />
                            )}
                        </div>
                    </div>
                    <div className={`flex_col flex_gsb g2 shown ${phase}`}>
                        <div className="flex_row justify-content_between">
                            <div className="small-title">
                                {phrases?.["15138"]}
                            </div>
                        </div>

                        <div className="flex_col g2 base p4 roundness_1 border_tt82 full-height">
                            {test.questions[0].answers?.[0]?.groupId === "1" &&
                                (location.state.test.id === 21226 &&
                                    test.questions[0].answers?.length === 9 ? (
                                    <SingleSelectTab
                                        singleSelectData={singleSelectData}
                                        setSingleSelectData={
                                            setSingleSelectData
                                        }
                                        data={test.questions[0].answers}
                                    />
                                ) : (
                                    test.questions[0].answers.map(
                                        (val, ind) => (
                                            <div
                                                key={test.startNumber + ind}
                                                className="radio-container"
                                            >
                                                <input
                                                    id={`option-${ind}`}
                                                    type="radio"
                                                    name="survey_options"
                                                    value={val.position}
                                                    onChange={(e) =>
                                                        setSingleSelectData(
                                                            e.target.value
                                                        )
                                                    }
                                                    checked={
                                                        singleSelectData ==
                                                        val.position
                                                    }
                                                />
                                                <label
                                                    dangerouslySetInnerHTML={{
                                                        __html: val.content,
                                                    }}
                                                    htmlFor={`option-${ind}`}
                                                />
                                            </div>
                                        )
                                    )
                                ))}
                            {test.questions[0].answers?.[0]?.groupId === "2" &&
                                test.questions[0].answers.map((val, ind) => (
                                    <div
                                        key={test.startNumber + ind}
                                        className="checkbox-container"
                                    >
                                        <input
                                            id={`option-${ind}`}
                                            type="checkbox"
                                            value={val.position}
                                            checked={
                                                multiSelectData[val.position]
                                            }
                                            onChange={(e) =>
                                                updateMultiSelect(
                                                    e.target.value
                                                )
                                            }
                                        />
                                        <label
                                            dangerouslySetInnerHTML={{
                                                __html: val.content,
                                            }}
                                            htmlFor={`option-${ind}`}
                                        />
                                    </div>
                                ))}
                            {test.questions[0].answers?.[0]?.groupId === "3" &&
                                (location.state.test.id === 21226 &&
                                    test.startNumber === 35 ? (
                                    <Q35
                                        textData={textData}
                                        setTextData={setTextData}
                                        nextAllowed={nextAllowed}
                                        nextNavigate={nextNavigate}
                                    />
                                ) : (
                                    <div key={test.startNumber}>
                                        <input
                                            id={`option-${test.startNumber}`}
                                            type="text"
                                            value={textData}
                                            autocomplete="off"
                                            autocorrect="off"
                                            autocapitalize="off"
                                            spellcheck="false"
                                            onChange={(e) =>
                                                setTextData(e.target.value)
                                            }
                                            onKeyDown={(e) => {
                                                e.stopPropagation();
                                                if (e.code === "Enter") {
                                                    e.preventDefault();
                                                    if (nextAllowed()) {
                                                        nextNavigate();
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                ))}
                            {test.questions[0].freeField && (
                                <div className="input-wrapper ">
                                    <textarea
                                        onChange={(e) =>
                                            setFreeFieldData(e.target.value)
                                        }
                                        autocomplete="off"
                                        autocorrect="off"
                                        autocapitalize="off"
                                        spellcheck="false"
                                        onKeyDown={(e) => e.stopPropagation()}
                                        value={freeFieldData}
                                        id="freeFieldId"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <hr />
                <div className="flex_col_reverse_mobile flex_row align-items_center justify-content_between g2">
                    {test.lastPage && !location.state.warmUp ? (
                        <div />
                    ) : (
                        <button
                            type="button"
                            className="button-secondary text_uppercase full-width_mobile"
                            onClick={exitTest}
                            disabled={loading}
                        >
                            {location.state.warmUp
                                ? phrases?.["1000229"]
                                : phrases?.["1002190"]}
                        </button>
                    )}
                    <div className="flex g4 text_uppercase">
                        {test.startNumber !== 1 &&
                            location.state.test.previosNavegation && (
                                <a
                                    role="link"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        nextNavigate(true);
                                    }}
                                >
                                    <span className="material-icons left">
                                        arrow_back
                                    </span>
                                    {phrases?.["410"]}
                                </a>
                            )}
                        <button
                            type="button"
                            className="button-primary text_uppercase full-width_mobile"
                            disabled={!nextAllowed() || loading}
                            onClick={() => nextNavigate()}
                        >
                            {test.lastPage
                                ? location.state.warmUp
                                    ? phrases?.["11070"]
                                    : phrases?.["15140"]
                                : phrases?.["10976"]}
                            <span className="material-icons right">
                                arrow_forward
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <CommonPopup
                popupData={popupData}
                closeAction={closePopUp}
                approveAction={approveAction}
                setterFun={setpopupData}
            />
            <SessionExpireCommonPopup
                sessionStatus={sessionStatus}
                sessionApproveAction={sessionApproveAction}
            />
        </form>
    );
};

export default TestTaker32;
